import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DiscountData } from "../../entry/server/app.ts";
import { appRepo } from "../../repo/app-repo.ts";
import { AppContext } from "../../context/app-context.tsx";
import { toTehranDateString } from "../../utils/common_helpers.ts";
import PaginationView from "../../componrnts/pagination.tsx";
import { Pagination } from "../../lib/api.ts";

export default function DiscountsList() {
  const [discounts, setDiscounts] = useState<DiscountData[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);
  const [loading, setLoading] = useState(true);
  const { setMessage } = useContext(AppContext);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchDiscounts = async () => {
      setLoading(true);
      try {
        const response = await appRepo.getDiscounts(page);
        if (!response.status || !response.data) {
          setMessage({ type: "error", message: response.message || "دریافت لیست کدهای تخفیف ناموفق بود." });
          setDiscounts([]);
          return;
        }
        setDiscounts(response.data);
        setPagination(response.pagination)
      } catch {
        setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
        setDiscounts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDiscounts();
  }, [setMessage, page]);

  const onDeleteDiscount = async (id: number) => {
    if (!window.confirm("آیا از حذف این کد تخفیف مطمئن هستید؟")) {
      return;
    }

    try {
      const response = await appRepo.deleteDiscount(id);
      if (!response.status) {
        setMessage({ type: "error", message: response.message || "حذف کد تخفیف با خطا مواجه شد." });
        return;
      }
      setDiscounts((prev) => prev.filter((item) => item.id !== id));
      setMessage({ type: "success", message: "کد تخفیف با موفقیت حذف شد." });
    } catch {
      setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
    }
  };

  if (loading) {
    return (
      <section className="mt-4 space-y-4">
        <div className="flex items-center justify-end">
          <Link
            to="/admin/discount-codes/new"
            className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
          >
            ایجاد کد تخفیف
          </Link>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          در حال دریافت لیست کدهای تخفیف...
        </div>
      </section>
    );
  }

  if (!discounts.length) {
    return (
      <section className="mt-4 space-y-4">
        <div className="flex items-center justify-end">
          <Link
            to="/admin/discount-codes/new"
            className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
          >
            ایجاد کد تخفیف
          </Link>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          هنوز هیچ کد تخفیفی ثبت نشده است.
        </div>
      </section>
    );
  }

  return (
    <section className="mt-4 space-y-4">
      <div className="flex items-center justify-end">
        <Link
          to="/admin/discount-codes/new"
          className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
        >
          ایجاد کد تخفیف
        </Link>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/60">
        <table className="min-w-full divide-y divide-slate-800 text-sm">
          <thead className="bg-slate-900/80">
            <tr>
              <th className="px-4 py-3 text-right font-medium text-slate-300">شناسه</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">کد</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">درصد تخفیف</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">حداکثر استفاده</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">تاریخ انقضا</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">پلن‌ها</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">وضعیت</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">عملیات</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {discounts.map((discount) => (
              <tr key={discount.id} className="transition hover:bg-slate-900">
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{discount.id}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-100">{discount.code}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{discount.discount_percentage}%</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{discount.max_uses > 0 ? discount.max_uses : "بدون محدودیت"}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300 ltr text-right">{toTehranDateString(discount.expires_at) || "-"}</td>
                <td className="px-4 py-3 text-slate-300">{discount.plans_id?.length ? discount.plans_id.join(", ") : "-"}</td>
                <td className="px-4 py-3">
                  <span
                    className={`rounded-full px-3 py-1 text-xs font-medium ${
                      discount.is_active
                        ? "bg-emerald-500/20 text-emerald-300"
                        : "bg-slate-700/60 text-slate-300"
                    }`}
                  >
                    {discount.is_active ? "فعال" : "غیرفعال"}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <Link
                      to={`/admin/discount-codes/${discount.id}/edit`}
                      className="inline-flex rounded-lg border border-slate-700 px-3 py-1.5 text-xs text-slate-200 transition hover:border-indigo-400 hover:text-indigo-300"
                    >
                      ویرایش
                    </Link>
                    <button
                      type="button"
                      onClick={() => onDeleteDiscount(discount.id)}
                      className="inline-flex rounded-lg border border-rose-700 px-3 py-1.5 text-xs text-rose-200 transition hover:border-rose-500 hover:text-rose-300"
                    >
                      حذف
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <PaginationView pagination={pagination} onPageChange={setPage} />
    </section>
  );
}
